import React, { FC, useEffect, useRef, useState, type JSX } from 'react';
import { NextArrowIcon, PrevArrowIcon } from '../../../icons';
import {
  StyledButton,
  StyledLoaderDiv,
  StyledModal,
  StyledNextSliderButton,
  StyledSlideItem,
  StyledSlideItemModal,
  StyledSlider1,
  StyledSlider2,
  StyledSliderMobile,
  StyledSliders,
  StyledVisibleSlider,
} from './styles';
import { useAppSelector } from '../../../hooks/reduxHooks';
import { Box, Modal, CircularProgress, IconButton } from '@mui/material';
import Slider from 'react-slick';
import { StyledSlider } from '../../../components/HomePageSlider/HomePageSlider.styled';
import { Settings as ReactSlickSettings } from 'react-slick';
import { SliderDot } from '../../../components/HomePageSlider/SliderDot';
import { GlassMagnifier } from '@stepkillah/react-image-magnifiers';

import Image from 'next/image';
import styles from './styles.module.css';
import { IProduct } from '../../../interfaces/product';
import CloseIcon from '@mui/icons-material/Close';

interface ProductSlideProps {
  ssrProduct?: IProduct;
}

const ProductSlide: FC<ProductSlideProps> = ({ ssrProduct }) => {
  const state = useAppSelector((store) => store.products);
  const [open, setOpen] = useState<boolean>(false);
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [timeClicked, setTimeClicked] = useState<number>(0);

  const [product, setProduct] = useState<IProduct | undefined>(ssrProduct);
  const [loading, setLoading] = useState<boolean>(state.loading);

  useEffect(() => {
    setLoading(state.loading);
  }, [state.loading]);

  useEffect(() => {
    if (state.product) setProduct(state.product);
  }, [state.product]);

  let slider1 = useRef<any>(null);

  const SlickButtonFix = (props: { children: JSX.Element; slideCount?: number; currentSlide?: number }) => {
    const { children, currentSlide, slideCount, ...others } = props;
    return <span {...others}>{children}</span>;
  };

  const settingsMobile: ReactSlickSettings = {
    customPaging: function () {
      return (
        <button className='slickMobilePager'>
          <SliderDot />
        </button>
      );
    },
    appendDots: (dots) => <ul>{dots}</ul>,
    dots: true,
    dotsClass: `slick-thumb ${styles.slickDots}`,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const setting3 = {
    slidesToShow: 1,
    arrows: true,
    infinite: product?.images?.length ? product.images.length > 1 : false,
    initialSlide: currentSlide,

    nextArrow: (
      <SlickButtonFix>
        <StyledButton style={{ backgroundColor: 'white' }}>
          <NextArrowIcon size={9} />
        </StyledButton>
      </SlickButtonFix>
    ),
    prevArrow: (
      <SlickButtonFix>
        <StyledButton style={{ backgroundColor: 'white' }}>
          <PrevArrowIcon size={9} />
        </StyledButton>
      </SlickButtonFix>
    ),
  };
  const setting2 = {
    swipeToSlide: true,
    focusOnSelect: false,
    dots: false,
    vertical: true,
    verticalSwiping: true,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
  };
  const settings = {
    slidesToShow: 1,
    dots: false,
    arrows: false,
    infinite: false,
    nextArrow: <></>,
    prevArrow: <></>,
    beforeChange: (currentSlide: number, nextSlide: number) => {
      setCurrentSlide(nextSlide);
    },
    customPaging: (index: number) => {
      return <div className='ft-slick__dots--custom' />;
    },
  };
  const slider = React.useRef<Slider>(null);
  return (
    <>
      <div className={product && product?.images?.length > 1 ? styles.container : styles.onePhotoContainer}>
        {!loading && product?.images ? (
          <>
            <StyledVisibleSlider sx={{ mt: { xs: 1, md: 5 }, padding: '24px 20px', paddingTop: '0px', height: '90%' }}>
              <Box width='100%' height='100%'>
                <Box height='100%' width='100%'>
                  <StyledSlider sx={{ minHeight: 300 }} {...settingsMobile}>
                    {product?.images?.slice(0, 10)?.map((item, index) => (
                      <StyledSliderMobile key={index}>
                        <Image
                          key={index}
                          src={item?.url}
                          alt={item?.fileName ?? 'image'}
                          width={600}
                          height={800}
                          priority={index === 0}
                          onMouseDown={(e) => {
                            setTimeClicked(e.timeStamp);
                          }}
                          onMouseUp={(e) => {
                            if (e.timeStamp - timeClicked < 200) {
                              setOpen(true);
                            }
                          }}
                        />
                      </StyledSliderMobile>
                    ))}
                  </StyledSlider>
                </Box>
              </Box>
            </StyledVisibleSlider>
            <StyledSliders>
              {product && product?.images?.length > 1 ? (
                <StyledSlider2>
                  <Slider ref={slider} {...setting2}>
                    {product?.images?.map((item, index) => (
                      <div key={index} className={`${styles.slideItem_2} ${styles.pagingImg}`}>
                        <Image
                          key={item?.path}
                          src={item?.url}
                          alt={item?.fileName ?? 'image'}
                          width={110}
                          height={130}
                          onMouseDown={(e) => {
                            setTimeClicked(e.timeStamp);
                          }}
                          onMouseUp={(e) => {
                            if (e.timeStamp - timeClicked < 200) {
                              slider1.current.slickGoTo(index);
                            }
                          }}
                        />
                      </div>
                    ))}
                  </Slider>
                  {product.images.length > 6 ? (
                    <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
                      <StyledNextSliderButton
                        onClick={() => slider?.current?.slickPrev()}
                        sx={{ transform: 'rotate(180deg)', marginTop: '-5px' }}
                      >
                        <svg
                          fill='#000000'
                          width={25}
                          viewBox='0 0 256 256'
                          id='Flat'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                          <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round'></g>
                          <g id='SVGRepo_iconCarrier'>
                            {' '}
                            <path d='M210.82861,125.17139a4.0006,4.0006,0,0,1,0,5.65722l-80,79.99951a3.9997,3.9997,0,0,1-5.65722,0l-80-79.99951a4.00026,4.00026,0,0,1,5.65722-5.65722L128,202.34277l77.17139-77.17138A4.00147,4.00147,0,0,1,210.82861,125.17139Zm-85.65722,5.65722a4.00088,4.00088,0,0,0,5.65722,0l80-80a4.00026,4.00026,0,0,0-5.65722-5.65722L128,122.34326,50.82861,45.17139a4.00026,4.00026,0,0,0-5.65722,5.65722Z'></path>{' '}
                          </g>
                        </svg>
                      </StyledNextSliderButton>
                      <StyledNextSliderButton onClick={() => slider?.current?.slickNext()}>
                        <svg
                          fill='#000000'
                          width={25}
                          viewBox='0 0 256 256'
                          id='Flat'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                          <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round'></g>
                          <g id='SVGRepo_iconCarrier'>
                            {' '}
                            <path d='M210.82861,125.17139a4.0006,4.0006,0,0,1,0,5.65722l-80,79.99951a3.9997,3.9997,0,0,1-5.65722,0l-80-79.99951a4.00026,4.00026,0,0,1,5.65722-5.65722L128,202.34277l77.17139-77.17138A4.00147,4.00147,0,0,1,210.82861,125.17139Zm-85.65722,5.65722a4.00088,4.00088,0,0,0,5.65722,0l80-80a4.00026,4.00026,0,0,0-5.65722-5.65722L128,122.34326,50.82861,45.17139a4.00026,4.00026,0,0,0-5.65722,5.65722Z'></path>{' '}
                          </g>
                        </svg>
                      </StyledNextSliderButton>
                    </Box>
                  ) : null}
                </StyledSlider2>
              ) : null}
              <StyledSlider1>
                <Slider {...settings} ref={slider1}>
                  {product?.images?.slice(0, 10)?.map((item, index) => (
                    <StyledSlideItem key={index}>
                      <div
                        onMouseDown={(e) => {
                          setTimeClicked(e.timeStamp);
                        }}
                        onMouseUp={(e) => {
                          if (e.timeStamp - timeClicked < 200) {
                            setOpen(true);
                          }
                        }}
                      >
                        <GlassMagnifier
                          imageSrc={item?.url}
                          imageAlt={item?.fileName}
                          key={index}
                          largeImageSrc={item?.url}
                        />
                      </div>
                    </StyledSlideItem>
                  ))}
                </Slider>
              </StyledSlider1>
            </StyledSliders>
          </>
        ) : (
          <StyledLoaderDiv>
            <CircularProgress classes={{ circle: styles.loaderColor }} />
          </StyledLoaderDiv>
        )}
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
          className='product-modal'
        >
          <StyledModal>
            <div
              style={{ display: 'flex', justifyContent: 'end', position: 'absolute', right: 10, top: -10, zIndex: 999 }}
            >
              <Box sx={{ background: 'white', borderRadius: '4px' }}>
                <IconButton aria-label='close' sx={{ color: 'black' }} onClick={() => setOpen(false)}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </div>
            <Slider {...setting3}>
              {product?.images?.map((item, index) => (
                <StyledSlideItemModal key={index}>
                  <Image key={item?.path} src={item?.url} alt={item?.fileName ?? 'image'} width={1920} height={1080} />
                </StyledSlideItemModal>
              ))}
            </Slider>
          </StyledModal>
        </Modal>
      </div>
    </>
  );
};

export default ProductSlide;
